const investorContactAllLang = {
	title: {
		tag: 'investor.contact_all.title',
		fr: 'Relation investisseur',
		en: 'Investor relationship',
	},
	description: {
		tag: 'investor.contact_all.description',
		fr: 'Trouvez les coordonnées des responsables de chaque fonds',
		en: 'Find the contact details of the managers of each fund',
	},
	btn: {
		tag: 'investor.contact_all.btn',
		fr: 'Voir les contacts',
		en: 'See all contacts',
	},
};

export default investorContactAllLang;
